<script>
import { mapState } from 'vuex'
import LadBestPriceMixin from '@/components/frontends/Price/components/mixin/best-price'
import LadAbstractPriceInline from '@/components/frontends/Price/components/abstract/inline'

export default {
  name: 'LadBestPriceInline',
  extends: LadAbstractPriceInline,
  mixins: [LadBestPriceMixin],
  computed: {
    ...mapState('settings', ['currency']),
    hasDiscount() {
      return this.discountAmount > 0
    },
    price() {
      return this.bestPrice.price
    },
    discountWithFormat() {
      return this.$options.filters.ladFnCurrency(
        this.discountAmount,
        this.currency,
        true,
        ''
      )
    },
    /** precio real sin descuento */
    withoutDiscount() {
      return this.$options.filters
        .ladFnCurrency(this.price, this.currency, false, '')
        .format(true)
    },
    discountAmount() {
      return this.bestPrice.discount
    },
    /** label del descuento en % */
    promoDiscount() {
      return this.hasDiscount &&
        this.promotion.discount_type === 'promotion_percent'
        ? `-${this.promotion.value}%`
        : ''
    },
  },
}
</script>
